import { Await, createFileRoute, defer, notFound } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, RouteName } from '@mews-commander/enums';
import {
    AvailabilityBlockDashboard,
    checkAvailabilityBlockDashboardPrivilege,
    initAvailabilityBlock,
    prefetchAvailabilityBlockDashboard,
} from '@mews-commander/modules/src/modules/availabilityBlock';
import { OverlayedLoader } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => {
    const guideLink = createGuideLink(ArticlePath.PickingUpReservationsInAvailabilityBlocks);
    const { availabilityBlockId } = Route.useParams();
    const { moduleLoadingPromise } = Route.useLoaderData();

    return (
        <Await promise={moduleLoadingPromise} fallback={<OverlayedLoader show />}>
            {() => <AvailabilityBlockDashboard availabilityBlockId={availabilityBlockId} guideLink={guideLink} />}
        </Await>
    );
};

export const Route = createFileRoute(
    '/_authenticated/$currentEnterpriseId/AvailabilityBlock/Dashboard/$availabilityBlockId'
)({
    // We are opting-out of cache, so each loader call alawys returns fresh promise
    // and not a cached one. That way, first render of block dashboard has always all the data.
    // https://tanstack.com/router/latest/docs/framework/react/guide/data-loading#using-shouldreload-and-gctime-to-opt-out-of-caching
    shouldReload: false,
    gcTime: 0,
    loader: async ({
        context: {
            getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: getState,
            dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: dispatch,
        },
        params: { availabilityBlockId },
    }) => {
        await prefetchAvailabilityBlockDashboard(dispatch, getState(), availabilityBlockId);

        const check = checkAvailabilityBlockDashboardPrivilege(getState(), availabilityBlockId);
        if (!check) {
            throw notFound();
        }
        const moduleLoadingPromise = defer(dispatch(initAvailabilityBlock({ availabilityBlockId })));
        return { moduleLoadingPromise };
    },
    component: Component,
    staticData: {
        routeName: RouteName.AvailabilityBlockDashboard,
        owner: MewsTeam.GroupsEvents,
        type: RouteType.Frontend,
    },
});
